const TRIGGERS = ["click", "hover"];
const DIRECTIONS = ["horizontal", "vertical"];
const ARROWS = ["always", "hover", "never"];
const INDICATORS = ["line", "dot", "slider", "never"];
const INDICATORS_POSITION = [
  "bottom",
  "top",
  "left",
  "right",
  "outer"
];
export { ARROWS, DIRECTIONS, INDICATORS, INDICATORS_POSITION, TRIGGERS };
